var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['home', { bgstyle: _vm.showMain }]},[_c('HeadNav'),_c('div',{attrs:{"id":"main"}},[_c('div',{class:['content', { homeBgStyle: _vm.showMain }]},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }